import firebase from "@/firebase/config";
import MtpEntranceMoved from "../views/MtpEntranceMoved.vue";

function authGuard(to, from, next) {
  if (!firebase.auth().currentUser) {
    next({ path: "/login", query: { unauthorized: "true" } });
    return;
  }
  next();
}

export const mtpEntranceRoutes = [
  {
    path: "/mtp-entrance/:pathMatch(.*)*",
    name: "MTP Entrance",
    component: MtpEntranceMoved,
    beforeEnter: authGuard,
  },
];
